import React, { Component, ReactNode } from 'react'
import { Translate } from 'react-localize-redux'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import classNames from 'classnames'

import { IPhoneFieldProps } from './Fields.interfaces'
import styles from './Fields.module.scss'

export default class PhoneField extends Component<IPhoneFieldProps, {}> {
  public render (): ReactNode {
    const {
      input,
      label,
      country,
      labelPosition,
      placeholder = '',
      size = 'large',
      required,
      meta: { error, visited }
    } = this.props
    const isInlineDirection: boolean = labelPosition === 'inline'
    return (
      <div className={isInlineDirection ? styles.inputFlexWrap : styles.inputWrap}>
        {label &&
          <label className={isInlineDirection ? styles.inlineLabel : styles.inputLabel}>
            <Translate id={label} />
            {required ? <sup className={styles.required}>*</sup> : null}
          </label>
        }

        <Translate>
          {({ translate }) => (
            <PhoneInput
              country={country !== undefined ? country : 'us'}
              excludeCountries={['cu', 'ir', 'sy', 'kp']}
              {...input}
              // Property 'size' does not exist on type 'IntrinsicAttributes & PhoneInputProps & { children?: ReactNode; }'
              // @ts-ignore
              size={size}
              inputClass={classNames('ant-input ant-input-lg', styles.phone)}
              placeholder={translate(placeholder) as string}
            />
          )}
        </Translate>

        {visited && (error &&
          <label className={styles.errorLabel}><Translate id={error} /></label>
        )}
      </div>
    )
  }
}
